const { getClientId } = require("../services/requestorConfiguration.ts");

function stripProtocolForHost(value) {
  return value.replace(/^https?:\/\//i, "");
}

function stripPathAndQueryForHost(value) {
  return value.split("/")[0].split("?")[0].split("#")[0];
}

function stripPortForHost(value) {
  if (value.startsWith("[")) {
    const ipv6End = value.indexOf("]");

    if (ipv6End !== -1) {
      return value.slice(0, ipv6End + 1);
    }
  }

  return value.split(":")[0];
}

function isValidSanitizedHost(value) {
  if (!value) {
    return false;
  }

  if (value.startsWith("[") && value.endsWith("]")) {
    return value.length > 2;
  }

  return /^[a-z0-9.-]+$/i.test(value);
}

function sanitizeDealerHost(host) {
  if (typeof host !== "string") {
    return "";
  }

  const trimmedHost = host.trim();

  if (!trimmedHost) {
    return "";
  }

  const sanitizedHost = stripPortForHost(
    stripPathAndQueryForHost(stripProtocolForHost(trimmedHost))
  );
  const normalizedHost = sanitizedHost.toLowerCase();

  if (!isValidSanitizedHost(normalizedHost)) {
    return "";
  }

  return normalizedHost;
}

function resolveDealerHost({ incomingDealerHost, host } = {}) {
  const sanitizedIncomingDealerHost = sanitizeDealerHost(incomingDealerHost);

  if (sanitizedIncomingDealerHost) {
    return sanitizedIncomingDealerHost;
  }

  const sanitizedHost = sanitizeDealerHost(host);

  if (!sanitizedHost) {
    return "";
  }

  try {
    const resolvedClientId = getClientId(sanitizedHost);
    return sanitizeDealerHost(resolvedClientId || sanitizedHost);
  } catch {
    return sanitizedHost;
  }
}

module.exports = {
  sanitizeDealerHost,
  resolveDealerHost,
};
